import "core-js/modules/es.array.push.js";
import { COLUMNS, data } from './partten';
import infoModel from './infoModel.vue';
export default {
  components: {
    infoModel
  },
  data() {
    return {
      COLUMNS,
      form: {
        organizationId: '1'
      },
      organizationlist: [{
        id: '1',
        name: '泛华保险服务集团'
      }],
      data,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: data.length,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      infoShow: false
    };
  },
  methods: {
    getDataFun() {},
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleInfo(val) {
      this.infoShow = true;
      this.$nextTick(() => {
        this.$refs.infoForm.init(val);
      });
    },
    handleOk(val) {
      val.organizationName = '泛华保险服务集团';
      val.date = '2020-3';
      val.id = String(this.data.length);
      this.data.push(val);
    },
    handleExport(val) {
      console.log(val);
      window.location.href = 'http://test.home.console.insurforce.cn/excel/' + this.$t('产险业务报表') + '.xlsx';
    }
  }
};